import * as React from 'react';
import { MultipleChoiceSvarmulighed } from '../../models/MultipleChoiceSvarmulighed';
import RadioButton from '../../uiComponents/input/RadioButton';

export interface KonkurrenceDelopgaveSvarmulighedProps {
    selected?: boolean;
    disabled?: boolean;
    svarmulighed: MultipleChoiceSvarmulighed;
    onMultipleChoiceSvarChanged?: (spoergsmaalId: string, svarmulighedId: string) => void;
    getDelopgaveAfslutningstidspunkt?: () => void;
}

class KonkurrenceDelopgaveSvarmulighed extends React.Component<KonkurrenceDelopgaveSvarmulighedProps, any> {
    constructor(props: KonkurrenceDelopgaveSvarmulighedProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e: any) {
        if (this.props.onMultipleChoiceSvarChanged === undefined) {
            return;
        } else {
            this.props.onMultipleChoiceSvarChanged(this.props.svarmulighed.multipleChoiceSpoergsmaalId, this.props.svarmulighed.id);
            if (this.props.getDelopgaveAfslutningstidspunkt !== undefined) {
                this.props.getDelopgaveAfslutningstidspunkt();
            }            
        }
    }

    render() {
        return (
            <li className='delopgavesvarmulighed'>
                <RadioButton 
                    displayText={this.props.svarmulighed.svarmulighed}
                    value={this.props.svarmulighed.id}
                    disabled={this.props.disabled}
                    checked={this.props.selected}
                    onChange={this.onChange}
                /> 
            </li>
        );
    }
}

export default KonkurrenceDelopgaveSvarmulighed;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceDelopgaveSvarmulighed.tsx